<template lang="pug">
v-text-field(
  dense
  flat
  clearable
  :value="value"
  @input="onInputDebounce($event)"
  @change="onChange()"
  @click:clear="onClear"
  @focus="toggleInputFocusState"
  @blur="toggleInputFocusState"
  :placeholder="placeholder"
  data-test="search"
  ref="search_input"
)
  <template v-slot:prepend>
    v-icon(@click="onSearchIconClick") $vuetify.icons.search
  </template>
</template>
<script>
import debounce from "@/util/debounce";
export default {
  props: {
    value: {
      required: true
    },
    placeholder: String
  },
  data: () => ({
    isInputFocused: false,
    currentInput: null,
    changedInput: null,
  }),
  created() {
    this.currentInput = this.value;
    this.changedInput = this.value;
  },
  methods: {
    toggleInputFocusState() {
      this.isInputFocused = !this.isInputFocused;
      this.$emit('onFocusToggle', this.isInputFocused);
    },
    onInputDebounce: debounce(function (event) {
      this.currentInput = event;
      this.$emit('input', event);
      this.onChange()
    }, 300),
    onClear() {
      this.currentInput = '';
      this.changedInput = '';
      this.$emit('input', this.currentInput);
      this.$emit('change', this.currentInput);
    },
    onChange() {
      if (this.currentInput !== this.changedInput) {
        this.changedInput = this.currentInput;
        this.$emit('change', this.changedInput)
      }
    },
    onSearchIconClick() {
      this.$refs.search_input.focus();
      this.onChange()
    }
  }
}
</script>
<style lang="scss" scoped>
  .v-input.v-input--is-focused::v-deep {
    input {
      color: $primary-color;
    }
  }
  .v-input::v-deep {
    padding: 0;
    margin: 0;
    input {
      font-size: 14px;
      &::placeholder {
        font-size: 18px;
      }
    }
    .v-icon {
      font-size: 20px;
    }
    .v-input__slot {
      margin: 0;
      &:before {
        display: none;
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
</style>
